import type { FC } from "react";

import { Textfield, Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    CloseButton,
    FooterStyle,
    InputContainer,
    TextfieldWrapper,
    TopContainer,
} from "app/pages/website-analysis/traffic-sources/search/components/filters/styledComponents";
import { titleAndTooltip } from "app/pages/website-analysis/traffic-sources/search/components/filters/utilityFunctions";

import type { IExactUrlFilterContentProps } from "./ExactUrlFilterTypes";

export const ExactUrlFilterContent: FC<IExactUrlFilterContentProps> = ({
    selectedURL,
    handleChange,
    inputFieldTooltip,
    inputFieldTitle,
    inputHasError,
    errorMessage = translate("digitalsuite.backlinks.filter.url.input.error"),
    handleInputKeyUp,
    onCancelClick,
    onApplyClick,
    isApplyButtonDisabled,
}) => {
    return (
        <div>
            <TopContainer>
                {titleAndTooltip(inputFieldTooltip, inputFieldTitle)}
                <InputContainer hasSelected={false}>
                    <TextfieldWrapper>
                        <Textfield
                            defaultValue={selectedURL}
                            onChange={handleChange}
                            iconName={"globe"}
                            placeholder={translate(`digitalsuite.backlinks.table.filter.url.input.placeholder`)}
                            isFocused={false}
                            onKeyUp={handleInputKeyUp}
                            error={inputHasError}
                            errorMessage={errorMessage}
                        />
                    </TextfieldWrapper>
                </InputContainer>
            </TopContainer>
            <FooterStyle>
                <CloseButton
                    type={"flat"}
                    onClick={onCancelClick}
                    label={translate("ranking.distribution.filter.url.cancel.button")}
                />
                <Button
                    isDisabled={isApplyButtonDisabled}
                    onClick={onApplyClick}
                    label={translate("ranking.distribution.filter.url.apply.button")}
                />
            </FooterStyle>
        </div>
    );
};
